import { render, staticRenderFns } from "./DistributionMap.vue?vue&type=template&id=61e975c2"
import script from "./DistributionMap.vue?vue&type=script&lang=js"
export * from "./DistributionMap.vue?vue&type=script&lang=js"
import style0 from "./DistributionMap.vue?vue&type=style&index=0&id=61e975c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports